import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {FadePlate} from "@nolimitcity/slot-game/bin/timelinegameround/components/FadePlate";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {HorribleHeroesLayerConfig} from "../config/IHorribleHeroesLayerConfig";
import {TweenLite} from "gsap";

export class HorribleHeroesNearWinView extends BaseView {
    private _fullScreenFade: FadePlate;
    private _sideSparkL: TimelineSprite;
    private _sideSparkR: TimelineSprite;
    private _fire: TimelineSprite;
    private _layer: ScalableLayer;

    private _anticipationAnimStarted: boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(HorribleHeroesLayerConfig.REEL_ATTENTION.name);
    }

    public playSparkAnimation(reelId: number): void {
        const pos: number[] = Helper.getSymbolPositions(reelId, 0);
        const symW = HorribleHeroesGameConfig.instance.SYMBOL_WIDTH;
        this._sideSparkL.position.x = pos[0] - symW;
        this._fire.position.x = pos[0];
        this._sideSparkR.position.x = pos[0];

        this.stopAllAnimations();
        this._fire.show();
        this._fire.playLoop();
        this._sideSparkR.show();
        this._sideSparkR.playLoop();
        this._sideSparkL.show();
        this._sideSparkL.playLoop();
    }

    public fadeOutAnimation() {
        TweenLite.to(this._fullScreenFade, 0.1, {alpha: 0});
    }

    public fadeInAnimation() {
        TweenLite.to(this._fullScreenFade, 0.1, {alpha: 0.6});
    }

    public stopAllAnimations(): void {
        this._fire.stopLoop();
        this._fire.hide();
        this._sideSparkR.hide();
        this._sideSparkR.stopLoop();
        this._sideSparkL.hide();
        this._sideSparkL.stopLoop();
    }

    protected initAnimations(): void {
        this._fullScreenFade = new FadePlate(0x000000, 0.6);
        this._fullScreenFade.alpha = 0;

        this._fire = new TimelineSprite(GameResources.getTextures("fire"));
        this._fire.blendMode = PIXI.BLEND_MODES.ADD;
        this._fire.hide();
        this._fire.alpha = 0.4;
        this._fire.anchor.set(0.5, 0);

        this._sideSparkL = new TimelineSprite(GameResources.getTextures("side_spark"));
        this._sideSparkL.blendMode = PIXI.BLEND_MODES.ADD;
        this._sideSparkL.hide();

        this._sideSparkR = new TimelineSprite(GameResources.getTextures("side_spark"));
        this._sideSparkR.blendMode = PIXI.BLEND_MODES.ADD;
        this._sideSparkR.scale.set(-1, 1);
        this._sideSparkR.hide();

        this._sideSparkL.anchor.set(0, 0);
        this._sideSparkR.anchor.set(1, 0);

        this._fire.position.y = 23;
        this._sideSparkL.position.y = -25;
        this._sideSparkR.position.y = -25;
        this._layer.addChild(this._fire);
        this._layer.addChild(this._sideSparkL);
        this._layer.addChild(this._sideSparkR);
    }

    /**
     * @inheritDoc
     */
    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, () => this._anticipationAnimStarted = false);
    }

    protected onResize(resizeData: IResizeData): void {
        const symH = HorribleHeroesGameConfig.instance.SYMBOL_HEIGHT;
        const pos: number[] = Helper.getSymbolPositions(0, 0);
        const pos2: number = pos[1] + symH * 4;
        this._fire.y = 23;
        this._sideSparkL.y = -25;
        this._sideSparkR.y = -25;
        if (resizeData.orientation === "portrait") {
            this._fullScreenFade.resize(HorribleHeroesGameConfig.instance.REEL_AREA_POS_X, HorribleHeroesGameConfig.instance.REEL_AREA_POS_Y, HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH, HorribleHeroesGameConfig.instance.REEL_AREA_HEIGHT);
        }
    }

}